export type AppInputType = 'text' | 'number' | 'email'

export type AppInputState = 'static' | 'disabled' | 'success' | 'error'

export const APP_INPUT_TYPE = {
  Text: 'text',
  Number: 'number',
  Email: 'email',
} as const

export const APP_INPUT_STATE = {
  Static: 'static',
  Disabled: 'disabled',
  Success: 'success',
  Error: 'error',
} as const
